/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable no-useless-constructor */
import { useHistory } from 'react-router-dom';
import { GridColumn, Grid } from '@progress/kendo-react-grid';
import { withState } from '../../../../components/common/grid/WrappedGrid';
import WhitePad from '../../../../components/common/WhitePad/WhitePad';
import TitleComponent from '../../../../components/common/forms/Title/TitleComponent';
import { API_URL } from '../../../../utils/constants';
import createIcon from '../../../../static/img/createIcon.svg';
import GridWrapper from '~/src/components/common/GridWrapper';

export default function BrandsList(): JSX.Element {
  const history = useHistory();
  const url = `${API_URL}/products/brands/get`;

  const onRowClick = (rowInfo) => {
    history.push(`/brands/edit/${rowInfo.dataItem.id}`);
  };

  const StatefullGrid = withState(Grid, url, { onRowClick });

  const parentCell = (row) => {
    return <td>{row?.dataItem?.parentBrand?.name}</td>;
  };

  return (
    <WhitePad>
      <TitleComponent
        title="Brands"
        titleRight="Create"
        onRightHandler={(): void => history.push('/brands/create')}
        iconRight={createIcon}
        titleLeft="Back"
        onLeftHandler={(): void => history.goBack()}
      />
      <GridWrapper>
        <StatefullGrid>
          <GridColumn field="parentBrand" title="Parent Brand" cell={parentCell} />
          <GridColumn field="name" title="Brand" />
        </StatefullGrid>
      </GridWrapper>
    </WhitePad>
  );
}
